import {
  LogoSVG,
  LogoSVGCharging,
  LogoSVGEnergy,
  LogoSVGSolutions,
} from '@tmh-website/components/global/Header/Header.styles';

// noinspection ES6PreferShortImport
import type { LogoComponent, LogoId } from './useLogoComponent.contracts';

export const LOGO_IDS: Record<'Charging' | 'Default' | 'Energy' | 'Solutions', LogoId> = {
  Charging: 'TMH Charging' as LogoId,
  Default: 'TMH (default)' as LogoId,
  Energy: 'TMH Energy' as LogoId,
  Solutions: 'TMH Solutions' as LogoId,
};

export const LOGO_ID_TO_COMPONENT_MAP: Record<LogoId, LogoComponent> = {
  [LOGO_IDS.Charging]: () => <LogoSVGCharging height={40} />,
  [LOGO_IDS.Default]: () => <LogoSVG height={20} />,
  [LOGO_IDS.Energy]: () => <LogoSVGEnergy height={40} />,
  [LOGO_IDS.Solutions]: () => <LogoSVGSolutions height={40} />,
};
